import type { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { Button, Dialog, VideoCameraIcon } from "@/shared/ui";

export const ConsultationExistsAlert = ({
  ...props
}: ComponentProps<typeof Dialog.Root>) => {
  return (
    <Dialog.Root alert {...props}>
      <Dialog.Content withCloseButton={false}>
        <Dialog.Header icon={VideoCameraIcon}>
          <Dialog.Title>{t`You have a previous consultation already scheduled`}</Dialog.Title>

          <Dialog.Description>
            {t`It looks like you already have a consultation scheduled. To continue, please cancel your existing appointment first. We're here to help if you need any assistance!`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button size="lg" asChild>
            <Link
              to={ROUTES.CONSULTATIONS.OVERVIEW}
            >{t`Review consultations`}</Link>
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
